module.exports = __webpack_public_path__ + "img/decdesc1.8033efaf.png";